'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = clear;
exports.addStringifier = addStringifier;
exports.default = stringifyArgs;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var stringifiers = [];

function clear() {
  stringifiers = [];
}

function addStringifier(fn) {
  stringifiers.push(fn);
}

function checkStringifiers(arg, s) {
  return stringifiers.reduce(function (c, f) {
    return c || f(arg, s);
  }, false);
}

function stringifyArgs() {
  var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var separator = depth === 0 ? ' ' : ', ';
  if (depth > 3) {
    return '*Redacted*';
  }
  depth++; // eslint-disable-line

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return args.map(function (arg) {
    var pluginString = checkStringifiers(arg, function (z) {
      return stringifyArgs(depth, z);
    });
    if (pluginString) {
      return pluginString;
    }
    if (typeof arg === 'undefined') {
      return 'undefined';
    }
    if (arg === null) {
      return JSON.stringify(arg);
    }
    if (arg instanceof Array) {
      return '[' + stringifyArgs.apply(undefined, [depth].concat(_toConsumableArray(arg))) + ']';
    }
    if (typeof arg === 'string') {
      if (arg.length > 50) {
        return arg.substring(0, 47).concat('...');
      }
      return arg;
    }
    if (typeof arg === 'number') {
      return arg;
    }
    if (arg instanceof Object) {
      return '{ ' + Object.keys(arg).map(function (a) {
        return a + ': ' + stringifyArgs(depth, arg[a]);
      }).join(', ') + ' }';
    }
    if (arg instanceof Error) {
      return arg.toString();
    }
    if (typeof arg.toString === 'function') {
      return arg.toString();
    }
    return JSON.stringify(arg);
  }).join(separator);
}


//////////////////
// WEBPACK FOOTER
// ./~/jack-logs/util/stringifyArgs.js
// module id = 1175
// module chunks = 0